export default __webpack_public_path__ + "static/media/pic8.049c4bb2.jpg";